import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { isSDKCompatible } from '../VNAndroidSDK/Utils'
import { getAndroidSDKVersion } from '../VNAndroidSDK/Selectors'
import { bridge_getDeviceModel } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { DEVICE_MODEL } from '../VNMode/Utils'

const MIN_BACKBAR_APK_VERSION = '2.18.0'

/**
 * Used for development purposes to get the environment variables for
 * features being developted
 *
 * @returns {Object} - Object with the environment variables
 */
const useGetEnvVars = () => {
  const androidSDKVersion = useSelector(getAndroidSDKVersion)

  // BackBar - is APK version dependent
  const isBackBarEnabled = useCallback(() => {
    // include web browsers
    if (DEVICE_MODEL.WEB === bridge_getDeviceModel()) {
      return true
    }

    return isSDKCompatible(androidSDKVersion, MIN_BACKBAR_APK_VERSION)
  }, [androidSDKVersion])

  return { isBackBarEnabled }
}

export default useGetEnvVars
